import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/HeroCustom.scss';
import BackgroundSlider from '../home/BackgroundSlider';

const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="hero-container position-relative">
      <BackgroundSlider />
      <div className="hero-gradient-overlay" />
      <div className="hero-content d-flex align-items-center">
        <div className="header-bar me-3"></div>
        <h1 className="fw-bold fs-1">{t('services.hero.title')}</h1>
      </div>
      {/* <div className="hero-bottom-white" /> */}
    </div>
  );
};

export default Hero; 